import React from "react";
import { Navigate, Outlet } from "react-router-dom";

import { getRoles } from "../../utils/OktaHelpers";
import { isAuthorized } from "../../utils/RolesHelpers";
import { GLOBAL_ROUTES } from "../../utils/RoutesConstant";

const PrivateRoute = ({
    allowedRoles,
    redirect = GLOBAL_ROUTES.PageNotFound,
    forbidden,
}) => {
    return !forbidden &&
        (!allowedRoles || isAuthorized(allowedRoles, getRoles())) ? (
        <Outlet />
    ) : (
        <Navigate replace to={redirect} />
    );
};
export default PrivateRoute;
